import { globalPut } from '../index';

export const addBankAccount = (data) => {
  return globalPut(`/affiliation`, data);
};
